import * as actions from '@/store/actions/type';
import * as mutations from '@/store/mutations/type';

export default {
  [actions.SET_USER_INFO]({
    commit
  }, userInfo) {
    commit(mutations.SET_USER_INFO, userInfo);
  },
  [actions.SET_TOKEN]({
    commit
  }, token) {
    commit(mutations.SET_TOKEN, token);
  },
  [actions.SET_LNG]({
    commit
  }, lng) {
    commit(mutations.SET_LNG, lng);
  }
};



// WEBPACK FOOTER //
// ./src/store/actions/index.js